/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlFamilyProTemplateQueryVariables = Types.Exact<{
  templateId: Types.Scalars["String"]["input"];
}>;

export type GqlFamilyProTemplateQuery = {
  __typename: "Query";
  familyProTemplate?: {
    __typename: "FamilyProTemplate";
    inviteTemplate?: string | null;
  } | null;
};

export const FamilyProTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "familyProTemplate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "templateId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "familyProTemplate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "templateId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "templateId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "familyProTemplateFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "familyProTemplateFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FamilyProTemplate" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "inviteTemplate" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GqlFamilyProTemplateQuery,
  GqlFamilyProTemplateQueryVariables
>;
